export const mockArticles = [
  {
    id: 'a1',
    title: '蘑菇视频2024年度最受欢迎影视作品TOP10揭晓',
    slug: '2024-top-10-movies',
    summary: '回顾2024年，蘑菇视频平台涌现了大量优质影视作品。根据用户观看数据、评分和讨论热度，我们评选出了年度最受欢迎的十部作品。从国产科幻巨制到海外经典大片，这份榜单涵盖了电影、电视剧、动漫等多个类别，每一部都值得你反复观看。',
    content: `<p>2024年是影视行业蓬勃发展的一年，蘑菇视频平台累计上线了超过5000部新作品，总播放量突破200亿次。经过综合评选，以下是年度TOP10榜单：</p>
<h3>第一名：《繁花》</h3>
<p>王家卫导演的首部电视剧作品，以上海90年代为背景，讲述了阿宝在商海沉浮中的传奇故事。胡歌、马伊琍、唐嫣等实力派演员的精湛演技，加上电影级的画面质感，使《繁花》成为2024年当之无愧的话题之王。</p>
<h3>第二名：《流浪地球2》</h3>
<p>作为中国科幻电影的标杆之作，《流浪地球2》以更加宏大叙事和精良特效，讲述人类面对太阳危机时的抉择与勇气。影片不仅在国内取得58亿票房，更在海外市场获得广泛好评。</p>
<h3>第三名：《狂飙》</h3>
<p>这部扫黑除恶题材的剧集以其紧凑的剧情、深刻的人物刻画，成为2023-2024年度最具影响力的电视剧。张译饰演的安欣与张颂文饰演的高启强之间的正邪对决，让观众大呼过瘾。</p>`,
    image: 'https://readdy.ai/api/search-image?query=Movie%20awards%20ceremony%20concept%2C%20golden%20trophy%20on%20stage%20with%20spotlight%2C%20cinematic%20atmosphere%2C%20warm%20golden%20and%20dark%20tones%2C%20elegant%20minimalist%20composition%2C%20high%20quality%20photography&width=800&height=450&seq=article-top10-2024&orientation=landscape',
    date: '2024-12-28',
    author: '蘑菇编辑部',
    category: '影视资讯',
    views: '156,890',
    tags: ['年度盘点', '影视推荐', 'TOP10'],
  },
  {
    id: 'a2',
    title: '蘑菇视频会员权益全面升级：尊享八大特权',
    slug: 'vip-upgrade-2024',
    summary: '蘑菇视频会员体系迎来重大升级！即日起，会员用户可享受包括4K超清画质、杜比全景声、多端同步观看、抢先看热门剧集、专属客服等八项全新特权，让您的观影体验更上一层楼。',
    content: `<p>为回馈广大用户的支持与厚爱，蘑菇视频宣布会员权益全面升级。新会员体系已于12月1日正式上线，以下是升级后的八大核心权益：</p>
<h3>1. 4K超清画质</h3>
<p>所有会员专属内容均支持4K超清分辨率播放，配合HDR技术，呈现更细腻的画面细节和更真实的色彩还原。</p>
<h3>2. 杜比全景声</h3>
<p>精选内容支持杜比全景声音效，让您在家中也能享受影院级的沉浸式听觉体验。</p>
<h3>3. 多端同步观看</h3>
<p>一个会员账号支持手机、平板、电脑、电视四端同时登录，家人共享无忧。</p>
<h3>4. 抢先看特权</h3>
<p>热门剧集会员可提前解锁2-4集，不再苦苦等待更新。部分独家内容会员专享，全网独播。</p>`,
    image: 'https://readdy.ai/api/search-image?query=Premium%20membership%20concept%20image%2C%20golden%20crown%20on%20dark%20background%2C%20luxury%20elegant%20design%2C%20warm%20golden%20lighting%2C%20cinematic%20quality%2C%20minimalist%20composition&width=800&height=450&seq=article-vip-upgrade&orientation=landscape',
    date: '2024-12-15',
    author: '蘑菇会员中心',
    category: '平台动态',
    views: '89,432',
    tags: ['会员权益', 'VIP', '平台升级'],
  },
  {
    id: 'a3',
    title: '如何在蘑菇视频上找到最适合你的纪录片',
    slug: 'best-documentary-guide',
    summary: '纪录片是了解世界的最佳窗口。蘑菇视频拥有超过2000部优质纪录片，涵盖自然、历史、科技、人文等多个领域。本文为你推荐五大必看纪录片系列，并提供选片指南，帮你快速找到心仪的作品。',
    content: `<p>在快节奏的生活中，一部好的纪录片能让我们静下心来，重新认识这个世界。蘑菇视频平台收录了来自BBC、Discovery、NHK等全球顶级制作方的大量纪录片资源，如何从中挑选适合自己的？以下是我们的推荐指南：</p>
<h3>自然探索类推荐</h3>
<p>《蓝色星球II》《地球脉动III》《我们的星球》是自然纪录片的巅峰之作，以震撼的画面和深刻的生态思考，带领观众领略地球的壮美。</p>
<h3>历史人文类推荐</h3>
<p>《河西走廊》《故宫100》《如果国宝会说话》以独特的视角讲述中国历史文化，制作精良，内容扎实。</p>`,
    image: 'https://readdy.ai/api/search-image?query=Documentary%20film%20concept%2C%20vintage%20film%20camera%20with%20nature%20landscape%20reflection%20in%20lens%2C%20warm%20earthy%20tones%2C%20cinematic%20lighting%2C%20minimalist%20elegant%20composition&width=800&height=450&seq=article-documentary-guide&orientation=landscape',
    date: '2024-11-20',
    author: '蘑菇编辑部',
    category: '观影指南',
    views: '67,231',
    tags: ['纪录片', '观影指南', '自然'],
  },
  {
    id: 'a4',
    title: '蘑菇视频APP全新版本发布：界面焕新，体验升级',
    slug: 'app-new-version-2024',
    summary: '蘑菇视频APP 6.0版本正式上线！全新设计的用户界面更加简洁直观，新增智能推荐算法、离线下载加速、AI字幕生成等创新功能，让您的移动观影体验迈上新台阶。',
    content: `<p>经过半年的精心打磨，蘑菇视频APP 6.0版本终于与大家见面了！本次更新从界面设计到底层架构都进行了全面优化，以下是主要更新内容：</p>
<h3>全新视觉设计</h3>
<p>采用了更加简洁现代的UI风格，减少视觉干扰，让内容本身成为焦点。首页布局更加合理，个性化推荐更加精准。</p>
<h3>智能推荐升级</h3>
<p>基于深度学习的推荐算法，能够更准确地理解您的观影偏好，推荐真正符合您口味的优质内容。</p>
<h3>离线下载加速</h3>
<p>采用全新的P2P加速技术，下载速度提升300%，即使网络不稳定也能快速完成下载。</p>`,
    image: 'https://readdy.ai/api/search-image?query=Smartphone%20with%20video%20app%20interface%20on%20screen%2C%20modern%20minimalist%20design%2C%20warm%20lighting%2C%20clean%20background%20with%20plant%20decoration%2C%20tech%20lifestyle%20photography&width=800&height=450&seq=article-app-update&orientation=landscape',
    date: '2024-11-05',
    author: '蘑菇技术团队',
    category: '产品更新',
    views: '234,567',
    tags: ['APP更新', '新版本', '产品动态'],
  },
  {
    id: 'a5',
    title: '蘑菇视频少儿模式上线：给孩子一个安全的观影空间',
    slug: 'kids-mode-launch',
    summary: '蘑菇视频正式推出少儿模式功能，为0-12岁儿童提供专属的内容池和观看环境。家长可以设置观看时长限制、内容分级筛选，让孩子在安全、健康的环境中享受优质动画和教育内容。',
    content: `<p>关注儿童健康成长，蘑菇视频正式推出少儿模式。这一功能专为有孩子的家庭设计，旨在为儿童创造一个安全、适龄、有益的观影环境。</p>
<h3>专属内容池</h3>
<p>少儿模式下的所有内容均经过专业团队人工审核，确保内容健康、积极、富有教育意义。内容涵盖动画片、儿歌、科普知识、绘本故事等多个类别。</p>
<h3>家长控制功能</h3>
<p>家长可以设置每日观看时长、禁用时间段，以及根据孩子年龄选择合适的内容分级，全面掌控孩子的观影行为。</p>`,
    image: 'https://readdy.ai/api/search-image?query=Children%20watching%20tablet%20together%20happily%2C%20colorful%20playroom%20background%2C%20warm%20soft%20natural%20lighting%2C%20cozy%20family%20scene%2C%20lifestyle%20photography%20with%20warm%20tones&width=800&height=450&seq=article-kids-mode&orientation=landscape',
    date: '2024-10-18',
    author: '蘑菇产品团队',
    category: '平台动态',
    views: '198,345',
    tags: ['少儿模式', '家长控制', '新功能'],
  },
  {
    id: 'a6',
    title: '逐帧解析：《流浪地球2》中那些令人震撼的视觉特效',
    slug: 'wandering-earth-2-vfx',
    summary: '《流浪地球2》的特效制作达到了国产电影的新高度。本文带你深入幕后，解析太空电梯、月球核爆、行星发动机等关键场景的视觉特效是如何制作出来的，展现中国电影工业的飞速进步。',
    content: `<p>《流浪地球2》的视觉特效被业内誉为中国电影的里程碑。据统计，全片共有超过2000个特效镜头，由MOREVFX等多家国内顶尖特效公司联合完成。让我们逐一解析那些令人印象深刻的场景：</p>
<h3>太空电梯</h3>
<p>影片开场的太空电梯场景震撼了无数观众。这个长达9分钟的长镜头，从地面一路延伸至3.6万公里高的空间站，其制作难度堪称世界级。团队耗时18个月，使用程序化生成技术创建了庞大而精细的太空电梯模型。</p>
<h3>月球核爆</h3>
<p>月球表面的核爆场景是影片最令人心碎的时刻之一。特效团队通过物理模拟，精确还原了核爆在真空环境中的光辐射和冲击波效果，呈现出极具视觉冲击力的画面。</p>`,
    image: 'https://readdy.ai/api/search-image?query=Visual%20effects%20studio%20with%20computer%20screens%20showing%20CGI%20rendering%2C%20futuristic%20space%20scene%20on%20monitors%2C%20dark%20creative%20workspace%2C%20cinematic%20lighting%2C%20tech%20aesthetic&width=800&height=450&seq=article-vfx-analysis&orientation=landscape',
    date: '2024-09-22',
    author: '蘑菇编辑部',
    category: '影视技术',
    views: '145,678',
    tags: ['流浪地球', '视觉特效', '幕后解析'],
  },
];